import React from "react";

export const StoryMenuDeleteIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path
      d="M10.813,4.35H13.75V5.525H12.575v7.638a.587.587,0,0,1-.588.588H3.763a.588.588,0,0,1-.588-.588V5.525H2V4.35H4.938V2.588A.588.588,0,0,1,5.525,2h4.7a.588.588,0,0,1,.588.588Zm-4.7,2.938v3.525H7.288V7.288Zm2.35,0v3.525H9.638V7.288ZM6.113,3.175V4.35H9.638V3.175Z"
      transform="translate(-0.042 -0.042)"
      fill="#fff"
    />
  </svg>
);

export const StoryViewsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24.549"
    height="20.422"
    viewBox="0 0 24.549 20.422"
    {...props}
  >
    <path
      d="M1.182,13.211a12.483,12.483,0,0,1,24.549,0,12.483,12.483,0,0,1-24.549,0Zm12.274,5.673a5.673,5.673,0,1,0-5.673-5.673A5.673,5.673,0,0,0,13.456,18.884Zm0-2.269a3.4,3.4,0,1,1,3.4-3.4A3.4,3.4,0,0,1,13.456,16.615Z"
      transform="translate(-1.182 -3)"
      fill="#596970"
    />
  </svg>
);
